import { render } from "./DeleteJob.vue?vue&type=template&id=05af9546"
import script from "./DeleteJob.vue?vue&type=script&lang=js"
export * from "./DeleteJob.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__